import { svg } from "lit";
const icon = svg `<path d="M3.5 20.5V3.5H12.0096V4.99998H4.99997V19H12.0096V20.5H3.5ZM16.2308 16.2692L15.1923 15.1846L17.6269 12.75H9.09613V11.25H17.6269L15.1923 8.81538L16.2308 7.7308L20.5 12L16.2308 16.2692Z" fill="currentColor"/>`;
export default icon;
